const prefix = 'event:'
const trigger = 'voidtrigger'

const localStorageTransport = {
  listeners: {},
  install () {
    window.addEventListener('storage', ({key, newValue}) => {
      if (key.indexOf(prefix) === 0 && newValue !== trigger) {
        let event = key.substr(prefix.length);
        this.receive(event, newValue)
      }
    })
  },
  emit (event, data) {
    let newValue = data.toString()
    let param = prefix + event
    if (localStorage.getItem(param) === newValue) {
      localStorage.setItem(param, trigger)
    }
    localStorage.setItem(param, newValue)
  },
  on (event, fn) {
    if (!this.listeners[event]) {
      this.listeners[event] = []
    }
    this.listeners[event].push(fn)
  },
  receive (event, data) {
    if (this.listeners[event]) {
      for (let fn of this.listeners[event]) {
        fn(data)
      }
    }
  },
  off (event, fn) {
    if (this.listeners[event]) {
      for (let index in this.listeners[event]) {
        if (this.listeners[event][index] === fn) {
          this.listeners[event].splice(index)
          break
        }
      }
    }
  }
}
export default localStorageTransport